import { z } from "zod/v4";

export const ExperienceActionTypeList = [
  "start",
  "pause",
  "end",
  "delete",
  "reset",
] as const;

export type ExperienceActionType = (typeof ExperienceActionTypeList)[number];

export const ExperienceActionDtoSchema = z.object({
  id: z.uuid(),
  experienceId: z.uuid(),
  action: z.enum(ExperienceActionTypeList),
  actionTs: z.number(),
  performedBy: z
    .string()
    .nullish()
    .describe(
      "Email of the user who triggered this lifecycle event. Resolved from History records by matching action type and timestamp within a 5-minute window. Null if no matching History record is found, or if the record has no associated user. Currently only populated by GET /experiences/{experienceId}; list endpoints return null."
    ),
});

export type ExperienceActionDto = z.infer<typeof ExperienceActionDtoSchema>;
